function generateRandomString(): string {
  const array = new Uint32Array(56 / 2);
  window.crypto.getRandomValues(array);
  return Array.from(array, dec2hex).join('');
}

function dec2hex(dec: number): string {
  return ('0' + dec.toString(16)).substr(-2);
}

const sha256 = async (plain: string): Promise<ArrayBuffer> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return window.crypto.subtle.digest('SHA-256', data);
};

function base64urlencode(a: number[]): string {
  // Convert the ArrayBuffer to string using Uint8 array.
  // btoa takes chars from 0-255 and base64 encodes.
  // Then convert the base64 encoded to base64url encoded.
  // (replace + with -, replace / with _, trim trailing =)
  // return btoa(String.fromCharCode.apply(null, new Uint8Array(a)))
  //   .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  return btoa(String.fromCharCode.apply(null, a))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

async function pkceChallengeFromVerifier(verifier: string) {
  const hashed = await sha256(verifier);
  const base64encoded = base64urlencode(Buffer.from(hashed).toJSON().data);
  return base64encoded;
}

export { pkceChallengeFromVerifier, generateRandomString };
